import React from "react";
import { Tooltip, Button, ButtonPropsColorOverrides } from "@mui/material";
import { OverridableStringUnion } from "@mui/types";

interface TooltipButtonProps {
    option: string;
    optionSelected: string;
    tooltip: string;
    onClick: (option: string) => void;
    children: React.ReactNode;
    disabled?: boolean;
    color?: OverridableStringUnion<'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning', ButtonPropsColorOverrides>;
}

const TooltipButton = (props: TooltipButtonProps) => {
    // console.log(`TooltipButton.render: option=${props.option}, optionSelected=${props.optionSelected}`);
    return <Tooltip title={props.tooltip}>
        <Button 
            onClick={() => props.onClick(props.option)}
            variant={props.optionSelected == props.option ? "contained" : "outlined"}
            disabled={props.disabled}
            color={props.color || "primary"}
            // color={contentSelected === "survey-report" ? "primary" : "secondary"}
            >
            {props.children}
        </Button>
    </Tooltip>;
};

export default TooltipButton;
